import { gql } from '@apollo/client'
import { userDataCompressed } from '../../../common/fragments'

export const GET_TASKS = gql`
	query getArtTasks($art_id: ID $thumbnailResolution: String = "128x128") {
		getArtTasks(input: { art_id: $art_id }) {
			id
			type_id
			description
			assigned_by_user_id
			approval_required
			approved_by_user_id
			approval_at
			due_at
			is_completed
			created_by
			created_at
			modified_by
			modified_at
			is_deleted
			task_status_id

			# task_x_assigned_to
			assigned_to_type
			assigned_to_users {
				...userDataCompressed
				department
				is_deleted
			}
			assigned_to_department {
				id
				value
			}
		}
	}
	${userDataCompressed}
`

export const CREATE_TASK = gql`
	mutation createArtTask(
		$CreateTaskInput: CreateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		createArtTask(input: $CreateTaskInput) {
			code
			success
			message
			task {
				id
				type_id
				description
				assigned_by_user_id
				approval_required
				approved_by_user_id
				approval_at
				due_at
				is_completed
				created_by
				created_at
				modified_by
				modified_at
				is_deleted
				task_status_id
				# task_x_assigned_to
				assigned_to_type
				assigned_to_users {
					...userDataCompressed
					department
					is_deleted
				}
				assigned_to_department {
					id
					value
				}
			}
		}
	}
	${userDataCompressed}
`
export const DELETE_TASK = gql`
	mutation deleteArtTask($id: ID) {
		deleteArtTask(id: $id) {
			code
			success
			message
		}
	}
`

export const UPDATE_TASK = gql`
	mutation updateArtTask(
		$UpdateTaskInput: UpdateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		updateArtTask(input: $UpdateTaskInput) {
			code
			success
			message
			task {
				id
				type_id
				description
				assigned_by_user_id
				approval_required
				approved_by_user_id
				approval_at
				due_at
				is_completed
				created_by
				created_at
				modified_by
				modified_at
				is_deleted
				task_status_id

				# task_x_assigned_to
				assigned_to_type
				assigned_to_users {
					...userDataCompressed
					department
					is_deleted
				}
				assigned_to_department {
					id
					value
				}
			}
		}
	}
	${userDataCompressed}
`
